import { render, staticRenderFns } from "./DIGridItem.vue?vue&type=template&id=4d29306b&scoped=true"
import script from "./DIGridItem.vue?vue&type=script&lang=js"
export * from "./DIGridItem.vue?vue&type=script&lang=js"
import style0 from "./DIGridItem.vue?vue&type=style&index=0&id=4d29306b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29306b",
  null
  
)

export default component.exports